import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface UiButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  icon?: IconDefinition;
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  type?: 'button' | 'submit';
  className?: string;
}

const VARIANT_CLASS: Record<string, string> = {
  primary:   'text-white disabled:opacity-50',
  secondary: 'border border-gray-200 hover:bg-gray-50 text-gray-600 dark:border-slate-600 dark:hover:bg-slate-700 dark:text-slate-300',
  danger:    'bg-red-500 hover:bg-red-600 text-white disabled:opacity-50',
};

const UiButton: React.FC<UiButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
  icon,
  children,
  variant = 'primary',
  type = 'button',
  className = '',
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 disabled:cursor-not-allowed ${VARIANT_CLASS[variant]} ${className}`}
    style={variant === 'primary' ? { background: 'var(--theme-primary-gradient)' } : undefined}
  >
    {loading
      ? <FontAwesomeIcon icon={faSyncAlt} className="animate-spin" />
      : icon && <FontAwesomeIcon icon={icon} />
    }
    {children}
  </button>
);

export default UiButton;
